export default __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-01a2346da28ffacccd7c51e556a617f2.svg";